/* MY TOP SHOP — boutique : pastilles coloris, filtres & tri, fiche produit (galerie, variantes, panier) */
(function () {
  var d = document;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function euros(cents) {
    return (cents / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }

  /* ---------- Cartes : pastilles coloris ---------- */
  function cardSet(btn, commit) {
    var card = btn.closest('[data-mt-card]');
    if (!card) return;
    var label = card.querySelector('[data-mt-sw-name]');
    if (commit) {
      card.querySelectorAll('.mt-sw__b').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
      card.dataset.sel = btn.dataset.name;
      card.querySelectorAll('[data-mt-card-link]').forEach(function (a) { a.href = btn.dataset.url; });
      if (btn.dataset.img) {
        var img = card.querySelector('.mt-card__img img:not(.mt-card__alt)');
        if (img) {
          img.removeAttribute('srcset');
          img.src = btn.dataset.img;
          img.classList.remove('is-cut', 'is-studio');
          img.classList.add(btn.dataset.imgCls || 'is-cut');
        }
      }
    }
    if (label) { label.textContent = btn.dataset.name; label.classList.add('is-set'); }
  }
  function cardRestore(card) {
    var label = card.querySelector('[data-mt-sw-name]');
    if (!label) return;
    if (card.dataset.sel) { label.textContent = card.dataset.sel; label.classList.add('is-set'); }
    else { label.textContent = label.dataset.default; label.classList.remove('is-set'); }
  }
  d.addEventListener('click', function (e) {
    var b = e.target.closest('.mt-sw__b');
    if (b) { e.preventDefault(); cardSet(b, true); }
  });
  d.addEventListener('pointerover', function (e) {
    if (e.pointerType !== 'mouse') return;
    var b = e.target.closest('.mt-sw__b');
    if (b) cardSet(b, false);
  });
  d.addEventListener('pointerout', function (e) {
    if (e.pointerType !== 'mouse') return;
    var b = e.target.closest('.mt-sw__b');
    if (b && !b.contains(e.relatedTarget)) cardRestore(b.closest('[data-mt-card]'));
  });

  /* ---------- Collection : tri + tiroir filtres ---------- */
  function collection(scope) {
    (scope || d).querySelectorAll('[data-mt-coll]').forEach(function (coll) {
      if (coll.dataset.mtReady) return;
      coll.dataset.mtReady = '1';
      var sort = coll.querySelector('[data-mt-sort]');
      if (sort) sort.addEventListener('change', function () {
        var u = new URL(location.href);
        u.searchParams.set('sort_by', sort.value);
        u.searchParams.delete('page');
        location.href = u.toString();
      });
      var drawer = coll.querySelector('[data-mt-fdrawer]');
      var opener = coll.querySelector('[data-mt-filter-open]');
      if (!drawer || !opener) return;
      var form = drawer.querySelector('[data-mt-filters]');
      function open() {
        drawer.hidden = false;
        opener.setAttribute('aria-expanded', 'true');
        d.documentElement.style.overflow = 'hidden';
        var f = drawer.querySelector('input:not([type=hidden]),button');
        if (f) f.focus({ preventScroll: true });
      }
      function close() {
        drawer.hidden = true;
        opener.setAttribute('aria-expanded', 'false');
        d.documentElement.style.overflow = '';
        opener.focus({ preventScroll: true });
      }
      opener.addEventListener('click', open);
      drawer.querySelectorAll('[data-mt-filter-close]').forEach(function (x) { x.addEventListener('click', close); });
      d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) close(); });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var p = new URLSearchParams();
        new FormData(form).forEach(function (v, k) { if (String(v).trim() !== '') p.append(k, v); });
        if (sort) p.set('sort_by', sort.value);
        location.href = form.getAttribute('action') + (p.toString() ? '?' + p.toString() : '');
      });
    });
  }

  /* ---------- Fiche produit ---------- */
  function pdp(scope) {
    (scope || d).querySelectorAll('[data-mt-pdp]').forEach(function (el) {
      if (el.dataset.mtReady) return;
      el.dataset.mtReady = '1';
      var data = {};
      try { data = JSON.parse(el.querySelector('[data-mt-product-json]').textContent); } catch (err) { data = { variants: [] }; }

      /* Galerie */
      var track = el.querySelector('[data-mt-gal-track]');
      var items = track ? Array.prototype.slice.call(track.children) : [];
      var dots = el.querySelectorAll('.mt-gal__dots i');
      var thumbs = el.querySelectorAll('[data-mt-gal-thumb]');
      var prev = el.querySelector('[data-mt-gal-prev]');
      var next = el.querySelector('[data-mt-gal-next]');
      var cur = 0;
      function go(i, smooth) {
        if (!track || !items[i]) return;
        track.scrollTo({ left: items[i].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      }
      function mark(i) {
        cur = i;
        dots.forEach(function (x, k) { x.classList.toggle('is-on', k === i); });
        thumbs.forEach(function (x, k) { x.classList.toggle('is-on', k === i); });
        if (prev) prev.disabled = i === 0;
        if (next) next.disabled = i === items.length - 1;
      }
      if (track && items.length) {
        var t;
        track.addEventListener('scroll', function () {
          clearTimeout(t);
          t = setTimeout(function () { mark(Math.round(track.scrollLeft / track.clientWidth)); }, 60);
        }, { passive: true });
        thumbs.forEach(function (b) { b.addEventListener('click', function () { go(+b.dataset.mtGalThumb); }); });
        if (prev) prev.addEventListener('click', function () { go(Math.max(0, cur - 1)); });
        if (next) next.addEventListener('click', function () { go(Math.min(items.length - 1, cur + 1)); });
        track.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { e.preventDefault(); go(Math.min(items.length - 1, cur + 1)); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); go(Math.max(0, cur - 1)); }
        });
        mark(0);
      }
      function toMedia(id) {
        if (!id) return;
        for (var k = 0; k < items.length; k++) { if (+items[k].dataset.mediaId === +id) { go(k); return; } }
      }

      /* Variantes */
      var form = el.querySelector('[data-mt-form]');
      if (!form) return;
      var idInput = form.querySelector('[data-mt-variant-id]');
      var addBtn = form.querySelector('[data-mt-add]');
      var addLbl = form.querySelector('[data-mt-add-label]');
      var stock = el.querySelector('[data-mt-stock]');
      var now = el.querySelector('[data-mt-price-now]');
      var was = el.querySelector('[data-mt-price-was]');
      var sbar = el.querySelector('[data-mt-sbar]');
      var sbarPrice = el.querySelector('[data-mt-sbar-price]');
      var sbarAdd = el.querySelector('[data-mt-sbar-add]');
      var err = el.querySelector('[data-mt-err]');

      function selected() {
        return Array.prototype.map.call(form.querySelectorAll('[data-mt-opt]'), function (fs) {
          var c = fs.querySelector('input:checked');
          return c ? c.value : null;
        });
      }
      function update(scrollMedia) {
        var sel = selected();
        form.querySelectorAll('[data-mt-opt]').forEach(function (fs, i) {
          var b = fs.querySelector('[data-mt-opt-val]');
          if (b && sel[i]) b.textContent = sel[i];
        });
        var v = (data.variants || []).filter(function (x) {
          return x.options.every(function (o, i) { return o === sel[i]; });
        })[0];
        if (err) err.hidden = true;
        if (!v) {
          addBtn.disabled = true; addLbl.textContent = 'Indisponible';
          if (sbarAdd) sbarAdd.disabled = true;
          return;
        }
        idInput.value = v.id;
        now.textContent = euros(v.price);
        if (sbarPrice) sbarPrice.textContent = euros(v.price);
        if (v.compare > v.price) { was.textContent = euros(v.compare); was.hidden = false; } else { was.hidden = true; }
        addBtn.disabled = !v.available;
        addLbl.textContent = v.available ? 'Ajouter au panier' : 'Épuisé';
        if (sbarAdd) sbarAdd.disabled = !v.available;
        if (stock) {
          stock.classList.toggle('is-in', v.available);
          stock.querySelector('span').textContent = v.available ? 'En stock' : 'Épuisé pour le moment';
        }
        if (scrollMedia && v.media) toMedia(v.media);
        try { history.replaceState(null, '', v.url); } catch (e2) {}
      }
      form.querySelectorAll('[data-mt-opt-input]').forEach(function (r) { r.addEventListener('change', function () { update(true); }); });

      /* Quantité */
      var q = form.querySelector('[data-mt-qty-input]');
      form.querySelectorAll('[data-mt-qty]').forEach(function (b) {
        b.addEventListener('click', function () {
          q.value = Math.min(99, Math.max(1, (parseInt(q.value, 10) || 1) + (+b.dataset.mtQty)));
        });
      });

      /* Panier */
      var toast = el.querySelector('[data-mt-toast]');
      var toastTxt = el.querySelector('[data-mt-toast-txt]');
      var tt;
      function showToast(msg, bad) {
        if (!toast) return;
        toastTxt.textContent = msg;
        toast.classList.toggle('is-err', !!bad);
        toast.hidden = false;
        toast.style.animation = 'none'; void toast.offsetWidth; toast.style.animation = '';
        clearTimeout(tt);
        tt = setTimeout(function () { toast.hidden = true; }, 4200);
      }
      function setCount(n) {
        d.querySelectorAll('.mt-tools a[href$="/cart"]').forEach(function (a) {
          var c = a.querySelector('.mt-count');
          if (n > 0) {
            if (!c) { c = d.createElement('span'); c.className = 'mt-count'; a.appendChild(c); }
            c.textContent = n;
          } else if (c) { c.remove(); }
          a.setAttribute('aria-label', 'Panier (' + n + ')');
        });
      }
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addBtn.disabled) return;
        addBtn.classList.add('is-busy');
        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: +idInput.value, quantity: Math.max(1, parseInt(q.value, 10) || 1) }] })
        }).then(function (r) {
          return r.json().then(function (j) { return { ok: r.ok, j: j }; });
        }).then(function (res) {
          if (!res.ok) throw new Error(res.j.description || res.j.message || 'Ajout impossible.');
          return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
        }).then(function (cart) {
          setCount(cart.item_count);
          showToast('Ajouté au panier');
        }).catch(function (x) {
          if (err) { err.textContent = x.message; err.hidden = false; }
          showToast(x.message, true);
        }).then(function () { addBtn.classList.remove('is-busy'); });
      });

      /* Barre d'achat mobile */
      if (sbar) {
        var ticking = false;
        var check = function () {
          ticking = false;
          var on = addBtn.getBoundingClientRect().bottom < 0;
          if (on === sbar.classList.contains('is-on')) return;
          sbar.classList.toggle('is-on', on);
          sbar.setAttribute('aria-hidden', on ? 'false' : 'true');
          if (sbarAdd) sbarAdd.tabIndex = on ? 0 : -1;
        };
        d.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true, capture: true });
        window.addEventListener('resize', check);
        check();
        if (sbarAdd) sbarAdd.addEventListener('click', function () {
          if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true }));
        });
      }
    });
  }

  function init(scope) { collection(scope); pdp(scope); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  d.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
